const adminForm = {
 
  previewForm: [
    {
      type: 'label',
      label: 'ID',
      class: 'col-md-2 input-form',
      name: 'AlertNotificationId',
      id: 'AlertNotificationId',
      style: {},
    },
    {
      type: 'label',
      label: 'name',
      class: 'col-md-3 input-form',
      placeHolder: 'name',
      name: 'Name',
      id: 'Name',
      style: {},
    },
    {
      type: 'label',
      label: 'description',
      name: 'Description',
      class: 'col-md-3 input-form',
      id: 'Description',
      style: {},
    },
    {
      type: 'label',
      label: 'type',
      name: 'Type',
      class: 'col-md-2 input-form',
      id: 'Type',
      style: {}
    },
    {
      type: 'label',
      label: 'associated_clients',
      class: 'col-md-2 input-form',
      name: 'CountCustomer',
      id: 'CountCustomer'
    }

    // {
    //   type: 'Input',
    //   label: 'Confirm Password',
    //   class: 'col-md-4 input-form',
    //   placeHolder: '',
    //   name: 'ConfirmPassword',
    //   id: 'ConfirmPassword',
    //   datatype: 'Password',
    //   style: {},
    //   required: true
    // }
  ]
}
export default adminForm